import { GrFormClose } from "react-icons/gr";
import { Link } from "react-router-dom";
import Button from "../../Shared/Button/Button";

const WatchListOptions = () => {
  return (
    <div className="relative flex flex-col items-center justify-center border-l border-lightGray p-2.5">
      <GrFormClose className="absolute top-1 right-1 h-5 w-5 cursor-pointer" />
      <Button
        text={"Classified Ad"}
        variant="outline"
        className="mb-3 !border-primary !pt-2 !pb-2 !text-xs !text-primary "
      />
      <Link
        to="/auctionlisting"
        className="mb-5 flex w-full items-center justify-center"
      >
        <Button
          text="View Item"
          variant="secondary"
          className="w-4/5 pt-2 pb-2 !text-xs"
        />
      </Link>
      <Link to="/actionlisting">
        <p className="mb-2 font-pop text-xs font-semibold text-blue underline">
          View Auction BOB listing
        </p>
      </Link>
    </div>
  );
};

export default WatchListOptions;
